/**
 * Tipos compartidos del Panel de Filtros - V05.1
 * PTEL - Sistema de Normalización de Coordenadas
 */

import type { InfrastructureType, NormalizedInfrastructure } from '../../../types/infrastructure';
import type { MarkerGroup } from '../../../constants/markerConfig';

/**
 * Estado completo de los filtros
 */
export interface FilterState {
  /** Tipos seleccionados (vacío = todos) */
  selectedTypes: InfrastructureType[];
  /** Score mínimo 0-100 */
  minScore: number;
  /** Score máximo 0-100 */
  maxScore: number;
  /** Texto de búsqueda */
  searchText: string;
  /** Grupos expandidos en UI */
  expandedGroups: MarkerGroup[];
}

/**
 * Estado inicial por defecto
 */
export const DEFAULT_FILTER_STATE: FilterState = {
  selectedTypes: [],
  minScore: 0,
  maxScore: 100,
  searchText: '',
  expandedGroups: ['emergency', 'health'],
};

/**
 * Estadísticas de filtrado
 */
export interface FilterStats {
  total: number;
  filtered: number;
  byType: Partial<Record<InfrastructureType, number>>;
  scoreRange: { min: number; max: number; avg: number };
}

/**
 * Props del componente FilterPanel
 */
export interface FilterPanelProps {
  data: NormalizedInfrastructure[];
  filters: FilterState;
  onFiltersChange: (filters: FilterState) => void;
  position?: 'left' | 'right';
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  showStats?: boolean;
  showSearch?: boolean;
  className?: string;
}
